

    export interface IPriorityService {
        getColorByPriority: (priorityCode: string) => string;
        getIconByPriority: (priorityCode: string) => string;
    }

    export class PriorityService implements IPriorityService {

        constructor() { }

        public getColorByPriority = (priorityCode: string): string => {
            switch (priorityCode) {
                case 'CRIT':
                    return 'orangered';
                case 'HIGH':
                    return 'orange';
                default:
                    return '#00a7e5';
            }
        };

        public getIconByPriority = (priorityCode: string): string => {
            switch (priorityCode) {
                case 'CRIT':
                    return 'fa-arrow-up';
                case 'HIGH':
                    return 'fa-arrow-up';
                case 'LOW':
                    return 'fa-arrow-down';
                default:
                    return 'fa-arrows-h';
            }
        };
    }
